import {useTheme} from "@mui/material/styles";
import DangerousIcon from "@mui/icons-material/Dangerous";
import ReportIcon from "@mui/icons-material/Report";
import CheckIcon from "@mui/icons-material/Check";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import {Box, Typography} from "@mui/material";
import React from "react";

export default function TrueChecksActionCell({action}) {
    const theme = useTheme();
    let Icon;
    let color;
    switch (action?.toLowerCase()) {
        case "deny":
            Icon = DangerousIcon;
            color = theme.palette.accent.error;
            break;
        case "extended hold":
            Icon = ReportIcon
            color = theme.palette.accent.safetyorange;
            break;
        case "hold":
            Icon = ReportIcon
            color = theme.palette.accent.orange;
            break;
        case "none":
            Icon = CheckIcon
            color = theme.palette.accent.success;
            break;
        case "insufficient data":
            Icon = QuestionMarkIcon
            color = theme.palette.gray.main;
            break;
        default:
            Icon = null;
            color = null;
            break;
    }

    return (
        action && (
            <Box display="flex" alignItems="center" justifyContent="left" height="100%">
                {Icon && <Icon sx={{color: color}}/>}
                <Typography sx={{fontSize: 'inherit', marginLeft: .5}}>{action}</Typography>
            </Box>
        )
    )
}